import React, { Fragment } from "react";
import HeaderBotton from "../../../components/HeaderBottom";
import HeaderTop from "../../../components/HeaderTop";
import HeroSlider from "../../../components/HeroSlider";
import Service from "../../../components/Service";
import About from "../../../components/About";
// import {heroSliders} from '../global.js';
import ServiceArea from "../../../components/ServiceArea";
import Portfolio from "../../../components/Portfolio";
import Testmonial from "../../../components/Testmonial";
import ContactArea from "../../../components/ContactArea";
// import TeamMember from "../../../components/TeamMember";
// import CounterArea from "../../../components/CounterArea";
// import BlogArea from "../../../components/BlogArea";
// import NewsLetter from "../../../components/Newsletter";
import FooterArea from "../../../components/FooterArea";
// images
import about from "../../../images/about/2.jpg";
import signature from "../../../images/about/1.png";
import config from "../../../config";
// images
import portfolio1 from "../../../images/studies/1.jpg";
import portfolio2 from "../../../images/studies/2.jpg";
import portfolio3 from "../../../images/studies/3.jpg";
import portfolio4 from "../../../images/studies/4.jpg";
import portfolio5 from "../../../images/studies/5.jpg";
const heroSliders = [
  {
    images: "slideWrapperOne",
    title: "We have accumulated years of experience & a team of",
    subTitle: "super-talented and specialized lawyers.",
    text: "",
    button: "Contact us now",
    link: "Contact",
  },
  {
    images: "slideWrapperTwo",
    title: "We value our client's right to Justice",
    subTitle: "above all.",
    text: "",
    button: "Contact us now",
    link: "Contact",
  },
];

const services = [
  {
    icon: config.PageMenu.FamilyLaw.icon,
    title: config.PageMenu.FamilyLaw.title,
    content: config.PageMenu.FamilyLaw.content,
    link: config.PageMenu.FamilyLaw.link,
  },
  {
    icon: config.PageMenu.CivilLitigation.icon,
    title: config.PageMenu.CivilLitigation.title,
    content: config.PageMenu.CivilLitigation.content,
    link: config.PageMenu.CivilLitigation.link,
  },
  {
    icon: config.PageMenu.BusinessLaw.icon,
    title: config.PageMenu.BusinessLaw.title,
    content: config.PageMenu.BusinessLaw.content,
    link: config.PageMenu.BusinessLaw.link,
  },
  {
    icon: config.PageMenu.CriminalLaw.icon,
    title: config.PageMenu.CriminalLaw.title,
    content: config.PageMenu.CriminalLaw.content,
    link: config.PageMenu.CriminalLaw.link,
  },
  {
    icon: config.PageMenu.Immigration.icon,
    title: config.PageMenu.Immigration.title,
    content: config.PageMenu.Immigration.content,
    link: config.PageMenu.Immigration.link,
  },
  {
    icon: config.PageMenu.RealEstateLaw.icon,
    title: config.PageMenu.RealEstateLaw.title,
    content: config.PageMenu.RealEstateLaw.content,
    link: config.PageMenu.RealEstateLaw.link,
  },
  {
    icon: config.PageMenu.WillsEstate.icon,
    title: config.PageMenu.WillsEstate.title,
    content: config.PageMenu.WillsEstate.content,
    link: config.PageMenu.WillsEstate.link,
  },
];
const aboutText = config.Home;
// const aboutText = [
//   { text: '' },
//   { text: 'Ardent Law firm resulted from an idea to establish a reliable, trustworthy & full-service Law Firm.' },
//   { text: 'At Ardent Law Firm, we have accumulated years of experience & a team of super-talented and specialized lawyers. We listen to our clients\' issues in detail & later offer our tailored solutions to help them out.' },
//   { text: 'We believe in listening & inquiring about every little detail that matters. So when you hire us, you can expect good attention to everything you have to say. On top of it, we will ask the pointed but vital questions for additional information The better you answer them, the better we will be able to offer the solution. Because, ultimately, it\'s your answers that will help us prepare a rock-solid case for you.' },
//   { texth: 'Consult now' },
//   { textc: 'At Ardent, we value our client\'s right to justice above all. And that\'s precisely what has helped us cement our position in the justice system over the years. Whether its Criminal Law, Real Estate Law, Family Law, Business Law or Immigration Law, we have a dedicated team of specialists to assist you.' },
//   { textc: 'In short, we are a full-service Law firm in Ontario that specializes in assisting clients from various sections of society. ' },

// ];

const portfolioItem = [
  { images: portfolio1, title: "Criminal Law", subtitle: "Cirminal" },
  { images: portfolio2, title: "Family Law", subtitle: "Personal Issue" },
  {
    images: portfolio3,
    title: "Legal Matter",
    subtitle: "Wills/Power of Attorney",
  },
  { images: portfolio4, title: "Real Estate Law", subtitle: "Real Estate" },
  {
    images: portfolio5,
    title: "Business Law",
    subtitle: "Business",
  },
];

const Home = () => {
  return (
    <Fragment>
      <header className="headerArea">
      <HeaderBotton className="headerBottomArea" />
        <HeaderTop className="headerTop" />
       
      </header>
      <HeroSlider sliders={heroSliders} className="heroSliderArea" />
      <Service className="serviceArea" />
      <About
        className="aboutArea"
        title="About Us"
        subTitle="Full-service law firm in Ontario that you can rely on."
        images={about}
        signature={signature}
        pragraphs={aboutText}
      />
      <ServiceArea
        className="ourServiceArea"
        title="How Can We Help You"
        subTitle=" "
        services={services}
      />
      <Portfolio
        className="portfolioArea"
        // title="Our Resent Case Studies"
        // subTitle="Here Our Best Work"
        portfolioItem={portfolioItem}
      />
      <Testmonial className="testmonialArea" />
      <ContactArea className="contactArea" />
      {/* <TeamMember
        title="Qualified Attorneys "
        subTitle="Meet Our Experts"
        className="teamArea"
        slider={true}
      />
      <CounterArea className="counterArea" />
      <BlogArea
        className="blogArea"
        title="Latest News"
        subTitle="From Our Blog
                "
      />
      <NewsLetter className="newsLetterArea" /> */}
      <FooterArea />
    </Fragment>
  );
};
export default Home;
